import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-app-project-kanban-board',
  templateUrl: './app-project-kanban-board.component.html',
  styleUrls: ['./app-project-kanban-board.component.scss']
})
export class AppProjectKanbanBoardComponent implements OnInit {
  isCollapsed = true;
  status: boolean = false;
  modalRef: BsModalRef;
  constructor(private modalService: BsModalService) { }
  todo = [
    { 'title': 'Create new chat app', 'description': 'Contrary to popular belief, Lorem Ipsum is not simply random text.' },
    { 'title': 'Redesign store FIGMA', 'description': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.' },
  ];

  inprogress = [
    { 'title': 'Android app design', 'description': 'The point of using Lorem Ipsum is that it has a more-or-less normal distribution' },
    { 'title': 'IOS food app design', 'description': 'All the Lorem Ipsum generators on the Internet' },
    { 'title': 'Webapp design in FIGMA', 'description': 'All the Lorem Ipsum generators on the Internet' },
  ];

  done = [
    { 'title': 'Onepage landing', 'description': 'Contrary to popular belief, Lorem Ipsum is not simply random text.' },
    { 'title': 'Marketing Logo design', 'description': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.' },
  ];


  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
  }
  ngOnInit(): void {
  }
  ListViewEvent() {
    this.status = !this.status;
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

}
